var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    {
      staticClass: "app-footer inverted padding-y-2xl",
      staticStyle: {
        "--link-color": "var(--white)",
        "--link-hover-color": "var(--fa-blue)",
      },
      attrs: { id: "footer" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row roomy align-top" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "column-12 laptop:column-8" }, [
            _c(
              "div",
              {
                staticClass:
                  "display-flex flex-column laptop:flex-row laptop:flex-content-end tablet:size-sm",
                staticStyle: { width: "100%" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "display-flex flex-column tablet:flex-row margin-bottom-md laptop:margin-bottom-0 laptop:margin-right-2xl",
                    staticStyle: { gap: "var(--spacing-sm)" },
                  },
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "no-underline padding-right-3xs",
                        attrs: { to: { name: "license.pro" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_footer_link_click",
                              { destination: "license" }
                            )
                          },
                        },
                      },
                      [_vm._v("\n              License\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass:
                          "no-underline padding-left-0 padding-right-3xs tablet:padding-left-3xs",
                        attrs: { to: { name: "tos" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_footer_link_click",
                              { destination: "terms_of_service" }
                            )
                          },
                        },
                      },
                      [_vm._v("\n              Terms of Service\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass:
                          "no-underline padding-left-0 padding-right-3xs tablet:padding-left-3xs",
                        attrs: { to: { name: "privacy" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_footer_link_click",
                              { destination: "privacy_policy" }
                            )
                          },
                        },
                      },
                      [_vm._v("\n              Privacy Policy\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass:
                          "no-underline padding-left-0 padding-right-3xs tablet:padding-left-3xs",
                        attrs: { to: { name: "refunds" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_footer_link_click",
                              { destination: "refunds" }
                            )
                          },
                        },
                      },
                      [_vm._v("\n              Refunds\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "no-underline link flat text-left margin-0 padding-0 padding-left-0 padding-right-3xs tablet:padding-left-3xs",
                        staticStyle: { "--button-border-radius": "0" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.manageCookiePreferences.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              Cookie Preferences\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticStyle: { color: "var(--fa-gravy)" } }, [
                  _vm._v("© Fonticons, Inc."),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "column-12 laptop:column-4 margin-bottom-md laptop:margin-bottom-0",
      },
      [_c("h5", [_vm._v("Go Make Something Awesome")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }